export const TARGET_BID_MIN = 0.02
export const TARGET_BID_MAX = 1000000000
export const TARGET_BID_STEP = 0.1
export const TARGET_BID_PRECISION = 2
